import SessionsFilter from './SessionFilter';

export default SessionsFilter;
